export default __webpack_public_path__ + "static/media/empty-dashboard.c2d6da66.svg";